export enum CardEncodeType {
    None,
    JNF
}
